module.exports = __webpack_public_path__ + "img/top-10-product.3e7babd8.jpg";